import api from './axios';

const API_BASE = process.env.REACT_APP_API_URL || '';
const SERVER_ORIGIN = API_BASE.replace(/\/api\/?$/, '');

const MIME_TO_EXT = {
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/avif': 'avif',
  'image/svg+xml': 'svg',
};

function mimeFromDataUri(dataUri) {
  const match = dataUri.match(/^data:([^;,]+)/);
  return match?.[1] || 'image/png';
}

function fileFromDataUri(dataUri) {
  const mime = mimeFromDataUri(dataUri);
  const ext = MIME_TO_EXT[mime] || mime.replace(/^image\//, '').split('+')[0] || 'png';
  const base64 = dataUri.includes(',') ? dataUri.split(',')[1] : '';
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], `upload.${ext}`, { type: mime });
}

function fileFromBlob(blob, fallbackMime = 'image/png') {
  if (blob instanceof File && blob.type) {
    return blob;
  }
  const mime = blob.type || fallbackMime;
  const ext = MIME_TO_EXT[mime] || 'png';
  return new File([blob], `upload.${ext}`, { type: mime });
}

/** Resolve relative upload paths to absolute URLs for img src. */
export function resolveAssetUrl(url) {
  if (!url) return '';
  if (url.startsWith('data:') || url.startsWith('http://') || url.startsWith('https://') || url.startsWith('blob:')) {
    return url;
  }
  if (url.startsWith('/')) {
    return `${SERVER_ORIGIN}${url}`;
  }
  return url;
}

export const adminAlertTemplateApi = {
  list: async (params = {}) => {
    const res = await api.get('/admin/alert-templates', { params });
    return res.data;
  },

  listPickerOptions: async (params = {}) => {
    const res = await api.get('/admin/alert-templates/picker-options', { params });
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/admin/alert-templates/${id}`);
    return res.data;
  },

  create: async (data) => {
    const res = await api.post('/admin/alert-templates', data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.patch(`/admin/alert-templates/${id}`, data);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/admin/alert-templates/${id}`);
    return res.data;
  },

  clone: async (id) => {
    const res = await api.post(`/admin/alert-templates/${id}/clone`);
    return res.data;
  },

  publish: async (id) => {
    const res = await api.post(`/admin/alert-templates/${id}/publish`);
    return res.data;
  },

  getPlanInclusions: async (id) => {
    const res = await api.get(`/admin/alert-templates/${id}/plan-inclusions`);
    return res.data;
  },

  syncPlanInclusions: async (id, inclusions) => {
    const res = await api.put(`/admin/alert-templates/${id}/plan-inclusions`, { inclusions });
    return res.data;
  },

  upload: async (fileOrDataUri) => {
    const formData = new FormData();
    let uploadFile;
    if (typeof fileOrDataUri === 'string' && fileOrDataUri.startsWith('data:')) {
      uploadFile = fileFromDataUri(fileOrDataUri);
    } else if (fileOrDataUri instanceof Blob) {
      uploadFile = fileFromBlob(fileOrDataUri);
    } else {
      uploadFile = fileOrDataUri;
    }
    formData.append('file', uploadFile);

    const res = await api.post('/admin/alert-templates/upload', formData);
    const url = res.data?.data?.url || '';
    return resolveAssetUrl(url);
  },
};

export default adminAlertTemplateApi;
